export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-background-50 via-background-100 to-accent-50/30"></div>
      <div
        className="absolute inset-0 opacity-[0.05]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 65%, oklch(var(--primary-500)) 0.6px, transparent 0.6px), radial-gradient(circle at 80% 25%, oklch(var(--accent-500)) 0.6px, transparent 0.6px)",
          backgroundSize: '48px 48px',
        }}
      ></div>
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 pt-20 pb-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-2 bg-background-50/90 backdrop-blur-sm border border-background-200/70 px-4 py-1.5 rounded-full text-sm font-semibold text-foreground-800 mb-6">
              <span className="w-2 h-2 rounded-full bg-primary-500"></span>
              Sugargoo Spreadsheet Guide 2026
            </span>
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-extrabold text-foreground-950 leading-tight tracking-tight">
              Best Sugargoo Spreadsheet Guide &amp; Updated Lists 2026
            </h1>
            <p className="mt-5 text-base md:text-lg text-foreground-600 max-w-xl mx-auto lg:mx-0 leading-relaxed">
              Find the latest Sugargoo spreadsheet links, sneaker lists, streetwear finds,
              and shopping guides &mdash; updated regularly for the best deals.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto whitespace-nowrap bg-foreground-950 text-background-50 font-bold px-8 py-3.5 rounded-full text-sm hover:bg-foreground-800 transition-colors cursor-pointer flex items-center justify-center gap-2"
              >
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-store-line text-sm"></i></span>
                Sugargoo Spreadsheet
              </a>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto whitespace-nowrap font-bold text-foreground-950 px-8 py-3.5 rounded-full text-sm border-2 border-foreground-950 hover:bg-foreground-950 hover:text-background-50 transition-colors cursor-pointer flex items-center justify-center gap-2"
              >
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-shopping-bag-line text-sm"></i></span>
                Buy It Now
              </a>
            </div>
          </div>
          <div className="flex-1 w-full">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3] max-w-lg mx-auto lg:max-w-none">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20flat%20lay%20of%20stylish%20sneakers%20and%20fashion%20accessories%20on%20a%20warm%20terracotta%20and%20cream%20surface%2C%20soft%20window%20light%2C%20editorial%20product%20photography%2C%20minimal%20shadow%2C%20contemporary%20lifestyle%20aesthetic%2C%20high%20detail%20textures%2C%20warm%20earthy%20color%20palette&width=800&height=600&seq=hero-new-main-2026&orientation=landscape"
                alt="Sugargoo Spreadsheet Guide - Latest sneaker and streetwear finds"
                title="Sugargoo Spreadsheet Guide 2026 - Sneaker Lists & Shopping Resources"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/15 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}